import { makeStyles } from '@material-ui/core/styles';

import styles from './styles';

export default makeStyles(styles);
